import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../modules/content/service/types/filter.types';
import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import {
    OperationalReportTypeGridObject,
} from '@libs/types/src/services/object-type/service/operational-report-type.object';
import {
    OperationalReportTypeCreateInput
} from '@libs/types/src/services/input-type/services/operational-report-type/operational-report-type.create-input';
import {
    OperationalReportTypePatchInput
} from '@libs/types/src/services/input-type/services/operational-report-type/operational-report-type.patch-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';

@Injectable({ providedIn: 'root' })
export class OperationalReportTypeGqlService extends GqlServiceV2 {

    public getOperationalReportTypes(input: GridInput, fragment: string) {
        return this.query<OperationalReportTypeGridObject>(
            `
                query($input: GridInput!) {
                    operationalReportType {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createOperationalReportType(input: OperationalReportTypeCreateInput, fragment: string) {
        return this.mutate<OperationalReportTypeGridObject>(
            `
                mutation($input: OperationalReportTypeCreateInput!) {
                    operationalReportType {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createManyOperationalReportTypes(input: OperationalReportTypeCreateInput[], fragment: string) {
        return this.mutate<OperationalReportTypeGridObject[]>(
            `
                mutation($input: OperationalReportTypeCreateInput!) {
                    operationalReportType {
                        createMany(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public patchOperationalReportType(input: OperationalReportTypePatchInput, fragment: string = 'id') {
        return this.mutate<OkObject>(
            `
                mutation($input: OperationalReportTypePatchInput!) {
                    operationalReportType {
                        patch(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteOperationalReportType(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    operationalReportType {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
